export default "__VITE_ASSET__CnmeyjXz__"